<div class="black-overlay p-lg-5 p-5 text-center">
    <div class="h2 fw-medium mb-3 text-white">Learn about the technological innovations that <br>
        support the growth of the tourism industry.</div>
    <a routerLink="/signup" class="btn btn-lg white-btn blue-text fw-bold">Register Now</a>
</div>